export const ACTIVITIES_TAB_SEARCH_REQUEST = "ACTIVITIES_TAB_SEARCH_REQUEST";
export const ACTIVITIES_TAB_SEARCH_RESULT = "ACTIVITIES_TAB_SEARCH_RESULT";

export const ACTIVITIES_TAB_SEARCH_USERS_REQUEST = "ACTIVITIES_TAB_SEARCH_USERS_REQUEST";
export const ACTIVITIES_TAB_SEARCH_USERS_RESULT = "ACTIVITIES_TAB_SEARCH_USERS_RESULT";
export const ACTIVITIES_TAB_SEARCH_OPEN_MODAL = "ACTIVITIES_TAB_SEARCH_OPEN_MODAL";
export const ACTIVITIES_TAB_SEARCH_CLOSE_MODAL = "ACTIVITIES_TAB_SEARCH_CLOSE_MODAL";
